
import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { showModal } from "../../../features/modal/modalSlice"
import { useEffect, useState } from "react"
import { useScrollLock } from "../../../hooks/useScrollLock"
import styled from "styled-components"
import PageTopTitle from "../../shared/PageTopTitle"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import InputText from "../../shared/input/new/InputText"
import Btn from "../../shared/button/Btn"
import InputMail from "../../shared/input/new/InputMail"
import { addSubUser } from "../../../features/companyProfile/companyAuthorizationSlice"
import InputPhoneFormat from "../../shared/input/new/InputPhoneFormat"


const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 900px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-top: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;

        .content{
            padding: 40px 0;
            width: 500px;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 15px;
            .row{
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: space-between;
                gap: 10px;
            }
        }

        .button-grp{
            width: 100%;
            display: flex;
            justify-content: center;
            margin-top: auto;
            margin: 30px 0;
            gap: 50px;
        }
    }
`

const AddProfilimKullaniciModal = () => {
    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const {isLoadingAddSubUser } = useSelector(state => state.companyAuthorization)
    const { lockScroll, unlockScroll } = useScrollLock();

    const [isSubmitted, setIsSubmitted] = useState(false)


    const [phoneNumber,setPhoneNumber] = useState("")
    const [name, setName] = useState("")

    const [mail, setMail] = useState("")


    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])


    const handleSubmit = () => {
        setIsSubmitted(true)
        const submitData = {
            "email": mail,
            "phoneNumber": phoneNumber?.slice(2),
            "adSoyadUnvan": name
        }
        dispatch(addSubUser(submitData))
    }
    
  return (
    <ModalContainer onClick={()=> dispatch(showModal(null))}>
    <div className="modal" onClick={(e) => {e.stopPropagation(); dispatch(handleActiveSelect(null))}}>
        <PageTopTitle title={"Kullanıcı Ekle"}/>
        <div className="content">
            <div className="row">
                <InputMail data={mail} setData={(e) => setMail(e.target.value)} labelText={"Mail Adresi"} name={"mail"} inputWidth={"100%"}/>
                {/* <Btn bgColor={"transparent"} color={"#E85446"} width="100px">Kontrol Et</Btn> */}
            </div>
            <div className="row">
                <InputPhoneFormat data={phoneNumber} setData={setPhoneNumber} labelText={"Telefon"} name={"phoneNumber"} inputWidth={"100%"} />
                {/* <Btn bgColor={"transparent"} color={"#E85446"} width="100px">Kontrol Et</Btn> */}
            </div>
            <div className="row">
                <InputText data={name} setData={(e) => setName(e.target.value)} labelText={"Adı Soyadı"} name={"name"} inputWidth={"100%"}/>
            </div>
        </div>

        <div className="button-grp">
            <Btn bgColor={"transparent"} color={"#E85446"} width="280px" handleClick={handleSubmit}>Ekle</Btn>
            <Btn bgColor={"#E85446"} color={"#fff"} width="280px" handleClick={() => dispatch(showModal(null))}>Kapat</Btn>
        </div>
    </div>
</ModalContainer>
  )
}

export default AddProfilimKullaniciModal